// extracted by mini-css-extract-plugin
export var projectOverview = "projectOverview-module--projectOverview--EdawL";
export var description = "projectOverview-module--description--IeFtU";
export var date = "projectOverview-module--date--LEFjG";
export var tagList = "projectOverview-module--tagList--QGsfB";
export var highlighted = "projectOverview-module--highlighted--IvGaj";
export var infoList = "projectOverview-module--infoList--0xKdt";
export var normal = "projectOverview-module--normal--v0hfk";
export var link = "projectOverview-module--link--luSxX";